
<template>
  <div class="mybox">
    <ar ></ar>
    <ar orientation="topRight"></ar>
    <ar orientation="bottomLeft"></ar>
    <ar orientation="bottomRight"></ar>  
    <custitle v-if='showtxt' :txt="txt"/>      
    <slot></slot>
  </div>
</template>

<script>
   import DvDecoration3 from "@/components/datav/decoration3new/main"
import ar from "../arrow"
import custitle from "../custitle"
export default {
  name: 'cusbox',
  props: {  
      txt: {
        type: String,
        default: "你的标题"
      },    
      showtxt:{
         type: Boolean,
         default:true
      }
  },
  data () {  
    return {     
     
    }
  },
  methods: {
 
  },
  mounted () {
  
  },
  components:{
      ar,
      DvDecoration3,
      custitle
  }
}
</script>
<style lang="scss">
.mybox{
    height: 100%;
    width: 100%;
    position: relative;
    border: 2px solid #1D4191;
    background: rgba(76,151,230,0.06);
    display: flex;
    flex-direction: column;
    .title{
      display: flex;
      
    }
 }
 
</style>
